import { render, staticRenderFns } from "./PolicyScopeMeasuresIcon.vue?vue&type=template&id=459fe102&"
import script from "./PolicyScopeMeasuresIcon.vue?vue&type=script&lang=js&"
export * from "./PolicyScopeMeasuresIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports